import { gql } from "@apollo/client";

export const UPDATE_USER = gql`
  mutation($userId: ID!, $extraRoles: [String]!) {
    updateUser(userId: $userId, extraRoles: $extraRoles) {
      success
    }
  }
`;
